import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import jsonPost from '../../../util/jsonPost';

import Button from '../Atoms/Button';
import Input from '../Atoms/Input';
import ErrorMessage from '../Core/ErrorMessage';

const propTypes = exact({
  apiURL: PropTypes.string.isRequired,
  bookingReferenceHeading: PropTypes.string,
  bookingReferencePlaceholderText: PropTypes.string,
  buttonSubmitText: PropTypes.string,
  orderReferenceHeading: PropTypes.string,
  orderReferencePlaceholderText: PropTypes.string,
  validationMissingReference: PropTypes.string,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

const defaultProps = {
  bookingReferenceHeading: 'Booking Request Reference',
  bookingReferencePlaceholderText: 'Your booking reference',
  buttonSubmitText: 'Find your booking',
  orderReferenceHeading: 'Confirmed Booking Request',
  orderReferencePlaceholderText: 'Order reference',
  validationMissingReference: 'Please enter your booking reference request',
  siteId: null,
};

class MakePaymentFindBooking extends Component {
  constructor(props) {
    super(props);

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResetState = this.handleResetState.bind(this);

    this.findBookingFieldSets = [
      {
        fieldName: 'bookingReference',
        heading: props.bookingReferenceHeading,
        isRequired: true,
        key: 1,
        placeholder: props.bookingReferencePlaceholderText,
      },
      {
        fieldName: 'orderReference',
        heading: props.orderReferenceHeading,
        isRequired: false,
        key: 2,
        placeholder: props.orderReferencePlaceholderText,
      },
    ];

    this.state = {
      bookingReference: '',
      errorMessage: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    window.addEventListener('pageshow', this.handleResetState);
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handleResetState);
  }

  handleResetState() {
    this.setState({ isLoading: false });
  }

  handleFieldChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit() {
    if (!this.state.bookingReference) {
      return this.setState({ errorMessage: this.props.validationMissingReference });
    }

    this.setState({
      errorMessage: null,
      isLoading: true,
    });

    const options = {
      bookingReference: this.state.bookingReference,
      orderReference: this.state.orderReference,
      siteId: this.props.siteId,
    };

    return jsonPost(this.props.apiURL, options, (response) => {
      if (response.errorCode) {
        return this.setState({
          errorMessage: response.message,
          isLoading: false,
        });
      }

      window.location.href = response.redirectUri;
      return true;
    });
  }

  render() {
    return (
      <div className="MakePayment">
        <form className="MakePayment_form" autoComplete="off" noValidate>
          <div className="MakePayment_content">
            <div className="MakePayment_column MakePayment_column-inset">
              <div className="MakePayment_item">
                {this.findBookingFieldSets.map((field) => (
                  <div className="MakePayment_item MakePayment_item-1" key={field.key}>
                    <h4 className="MakePayment_itemHeading">{field.heading}</h4>
                    <Input
                      fieldName={field.fieldName}
                      fieldValue={this.state[field.fieldName]}
                      handleChange={this.handleFieldChange}
                      inputType="text"
                      isRequired={field.isRequired}
                      modifier="ghost"
                      placeholderText={field.placeholder}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="MakePayment_column">
              <div className="MakePayment_submit">
                {this.state.errorMessage && (
                  <div className="MakePayment_item">
                    <ErrorMessage text={this.state.errorMessage} />
                  </div>
                )}
                <div className="MakePayment_item MakePayment_item-center">
                  <Button
                    buttonType="button"
                    handleClick={this.handleSubmit}
                    isLoading={this.state.isLoading}
                    modifier="fill"
                    text={this.props.buttonSubmitText}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

MakePaymentFindBooking.defaultProps = defaultProps;
MakePaymentFindBooking.propTypes = propTypes;

export default MakePaymentFindBooking;
